import React from 'react'
import LandingBanner from '../components/landing-banner'
import Services from '../components/services'
import ServiceBanner from '../components/service-banner'
import CardSlider from '../components/card-slider'
import ImageTitleContent from '../components/image-title-content'
import Reviews from "../components/reviews";
import Awards from "../components/awards";
import TeamArchive from "../components/team-archive";
import Stats from "../components/stats";
import ImageBanner from "../components/image-banner";
import Faqs from "../components/faqs";
import Contact from '../components/contact'
import Cta from '../components/cta'
import Process from '../components/process'
import Image from '../components/image'
import Resources from '../components/resources'
import Resource from '../components/resource'
import Partners from "../components/partners";
import BasicPage from "../components/basic-page";

const renderBlock = (param, el, i) => {
  el.key = i

  let block = {
    'LandingBanner': (el) => <LandingBanner {...el} />,
    'Services': (el) => <Services {...el} />,
    'CardSlider': (el) => <CardSlider {...el} />,
    'ImageTitleContent': (el) => <ImageTitleContent {...el} />,
    'ServiceBanner': (el) => <ServiceBanner {...el} />,
    'Reviews': (el) => <Reviews {...el} />,
    'BasicPage': (el) => <BasicPage {...el} />,
    'Cta': (el) => <Cta {...el} />,
    'Faqs': (el) => <Faqs {...el} />,
    'ImageBanner': (el) => <ImageBanner {...el} />,
    'Stats': (el) => <Stats {...el} />,
    'Awards': (el) => <Awards {...el} />,
    'TeamArchive': (el) => <TeamArchive {...el} />,
    'ContactForm': (el) => <Contact {...el} />,
    'Process': (el) => <Process {...el} />,
    'Image': (el) => <Image {...el} />,
    'Resources': (el) => <Resources {...el} />,
    'Resource': (el) => <Resource {...el} />,
    'Partners': (el) => <Partners {...el} />
  }[param]

  if (!block) return null

  return block(el)
}

export default renderBlock